import WelcomeVideo from "./WelcomeVideo";
import TitleContainer from './TitleContainer';
export default function VideoContainer({mobile, height}){
  return (
      <div style={{
        //paddingTop:(!mobile?30:'unset'),
        //border:'3px solid green',
        paddingBottom:0,
        //marginLeft:(!mobile?30:'unset'),

        //width:(mobile?'unset':'60%'),
      }}
        //class={`full-height ${mobile ? "full-width" :""}`}
      >

        {false && !mobile && <TitleContainer mobile={mobile}/>}

        
        <div 
          class="white-shaddow-container" 
      style={{ //width:(mobile?'80vw':'55vw'), 
        border:'1px solid #eee',
        borderRadius:5,
        padding:10,
        }}>
          <WelcomeVideo height={height} />
        </div>
        
      </div>
  )
  
}
